"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUPTAbsenceEventRefreshTime = exports.getPointsAbsenceEventRefreshTime = exports.isInPayPeriodRange = exports.AttendanceLastUpdateTimeFeature = void 0;
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const hooks_1 = require("../../hooks");
const utils_1 = require("../../utils");
const TAAErrorBoundary_1 = require("../../components/Shared/TAAErrorBoundary");
const AttendanceLastUpdateTimeFeature = ({ attendanceEvent, timeZone, usageLocation, employeeId }) => {
    const { data: { pay_period_breakdown_info } = {} } = (0, hooks_1.usePayPeriod)({
        employeeId: employeeId,
        shouldFetch: true,
        usageLocation: usageLocation
    });
    let getAttendanceRefreshTime;
    if ((attendanceEvent === null || attendanceEvent === void 0 ? void 0 : attendanceEvent.model) === 'UPT') {
        getAttendanceRefreshTime = (0, exports.getUPTAbsenceEventRefreshTime)(timeZone, attendanceEvent, pay_period_breakdown_info);
    }
    else if ((attendanceEvent === null || attendanceEvent === void 0 ? void 0 : attendanceEvent.model) === 'POINTS') {
        getAttendanceRefreshTime = (0, exports.getPointsAbsenceEventRefreshTime)(timeZone, attendanceEvent, pay_period_breakdown_info);
    }
    else {
        getAttendanceRefreshTime = [];
    }
    const getHoursOrMinutes = (timeDate) => {
        const date = timeDate.toSeconds();
        const currDate = luxon_1.DateTime.now().toSeconds();
        return (0, utils_1.getHoursAndMinutes)(currDate - date);
    };
    return (react_1.default.createElement(TAAErrorBoundary_1.TAAErrorBoundary, null, getAttendanceRefreshTime.length > 0
        ? getHoursOrMinutes(getAttendanceRefreshTime[0])
        : ''));
};
exports.AttendanceLastUpdateTimeFeature = AttendanceLastUpdateTimeFeature;
const isInPayPeriodRange = (attendanceEvent, payPeriod) => {
    var _a, _b;
    return ((attendanceEvent === null || attendanceEvent === void 0 ? void 0 : attendanceEvent.absenceStartDateTime) >= ((_a = payPeriod === null || payPeriod === void 0 ? void 0 : payPeriod.current) === null || _a === void 0 ? void 0 : _a.start_time) &&
        (attendanceEvent === null || attendanceEvent === void 0 ? void 0 : attendanceEvent.absenceStartDateTime) <= ((_b = payPeriod === null || payPeriod === void 0 ? void 0 : payPeriod.current) === null || _b === void 0 ? void 0 : _b.end_time));
};
exports.isInPayPeriodRange = isInPayPeriodRange;
const getPointsAbsenceEventRefreshTime = (timeZone, attendanceEvent, payPeriod) => {
    const REFRESH_CHECKPOINT_0300 = luxon_1.Duration.fromObject({ hours: 3 });
    const REFRESH_CHECKPOINT_1600 = luxon_1.Duration.fromObject({ hours: 16 });
    let eventRefreshTime = [];
    const localTimeZone = timeZone ? timeZone : luxon_1.DateTime.local().zoneName;
    const currentTime = luxon_1.DateTime.local().setZone('America/Los_Angeles');
    const currentTimeStartOfADay = currentTime.startOf('day');
    const pointsEventRefreshCheckpoints = [
        currentTimeStartOfADay.minus({ days: 1 }).plus(REFRESH_CHECKPOINT_1600),
        currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_0300),
        currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_1600),
        currentTimeStartOfADay.plus({ days: 1 }).plus(REFRESH_CHECKPOINT_0300)
    ];
    if ((0, exports.isInPayPeriodRange)(attendanceEvent, payPeriod)) {
        for (let i = 0; i < pointsEventRefreshCheckpoints.length - 1; i++) {
            const [startTime, endTime] = [
                pointsEventRefreshCheckpoints[i],
                pointsEventRefreshCheckpoints[i + 1]
            ];
            const interval = luxon_1.Interval.fromDateTimes(startTime, endTime);
            if (interval.contains(currentTime)) {
                eventRefreshTime = [
                    startTime.setZone(localTimeZone),
                    endTime.setZone(localTimeZone)
                ];
                break;
            }
        }
    }
    else {
        const attendanceEventDate = luxon_1.DateTime.fromISO(attendanceEvent.absenceStartDateTime).setZone('America/Los_Angeles');
        const lastRefreshTime = attendanceEventDate
            .endOf('week')
            .plus(luxon_1.Duration.fromObject({ minutes: 1 }))
            .plus(REFRESH_CHECKPOINT_0300);
        eventRefreshTime = [lastRefreshTime.setZone(localTimeZone)];
    }
    return eventRefreshTime;
};
exports.getPointsAbsenceEventRefreshTime = getPointsAbsenceEventRefreshTime;
const getUPTAbsenceEventRefreshTime = (timeZone, attendanceEvent, payPeriod) => {
    const REFRESH_CHECKPOINT_0230 = luxon_1.Duration.fromObject({
        hours: 2,
        minutes: 30
    });
    const REFRESH_CHECKPOINT_0630 = luxon_1.Duration.fromObject({
        hours: 6,
        minutes: 30
    });
    const REFRESH_CHECKPOINT_1530 = luxon_1.Duration.fromObject({
        hours: 15,
        minutes: 30
    });
    const REFRESH_CHECKPOINT_1930 = luxon_1.Duration.fromObject({
        hours: 19,
        minutes: 30
    });
    const REFRESH_CHECKPOINT_1100 = luxon_1.Duration.fromObject({ hours: 11 });
    const localTimeZone = timeZone ? timeZone : luxon_1.DateTime.local().zoneName;
    const currentTime = luxon_1.DateTime.local().setZone('America/Los_Angeles');
    const currentTimeStartOfADay = currentTime.startOf('day');
    const uptEventRefreshCheckpoints = [];
    let eventRefreshTime = [];
    const isMonday = currentTime.weekday === 1;
    uptEventRefreshCheckpoints.push(currentTimeStartOfADay.minus({ days: 1 }).plus(REFRESH_CHECKPOINT_1930));
    uptEventRefreshCheckpoints.push(currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_0230));
    if (isMonday) {
        uptEventRefreshCheckpoints.push(currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_1100));
    }
    else {
        uptEventRefreshCheckpoints.push(currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_0630));
        uptEventRefreshCheckpoints.push(currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_1530));
    }
    uptEventRefreshCheckpoints.push(currentTimeStartOfADay.plus(REFRESH_CHECKPOINT_1930));
    uptEventRefreshCheckpoints.push(currentTimeStartOfADay.plus({ days: 1 }).plus(REFRESH_CHECKPOINT_0230));
    if ((0, exports.isInPayPeriodRange)(attendanceEvent, payPeriod)) {
        for (let i = 0; i < uptEventRefreshCheckpoints.length - 1; i++) {
            const [startTime, endTime] = [
                uptEventRefreshCheckpoints[i],
                uptEventRefreshCheckpoints[i + 1]
            ];
            const interval = luxon_1.Interval.fromDateTimes(startTime, endTime);
            if (interval.contains(currentTime)) {
                eventRefreshTime = [
                    startTime.setZone(localTimeZone),
                    endTime.setZone(localTimeZone)
                ];
                break;
            }
        }
    }
    else {
        const attendanceEventDate = luxon_1.DateTime.fromISO(attendanceEvent.absenceStartDateTime).setZone('America/Los_Angeles');
        const lastRefreshTime = attendanceEventDate
            .endOf('week')
            .plus(luxon_1.Duration.fromObject({ minutes: 1 }))
            .plus(REFRESH_CHECKPOINT_1100);
        eventRefreshTime = [lastRefreshTime.setZone(localTimeZone)];
    }
    return eventRefreshTime;
};
exports.getUPTAbsenceEventRefreshTime = getUPTAbsenceEventRefreshTime;
